<template> 
<div>
    <Row type="flex" justify="start" align="middle" :gutter="6" style="padding-top:5px;padding-bottom:5px;">
        <Col span='6'>
           <ShowText :label="fieldText" contentAlign="right" style="width:100%"></ShowText>
        </Col>
        <Col span='8'>
            <ControlBox   :valueData="data" :config="operConfig" @input="input" ></ControlBox>
        </Col>
        <Col span= '10'>
            <ControlBox   :valueData="data" :config="valueConfig" @input="input" style="width:100%" ></ControlBox>
        </Col>
    </Row>
</div>
</template>
<script>
    export default {
        name: 'billconditionbox',
        data () {
            return {
                operConfig:{
                    name:'oper',
                    type:'ComboBox',
                    codeWithName:false,
                    clearable:false,
                        //size:'small',
                    colNum:2,
                    data:[{
                        name: '等于',
                        code: '=='
                    }],
                    defaultValue:'==',
                },
                valueConfig:{
                    name:'value',
                    type:'TextBox',
                },
                dataType:{},
                data:{},
                fieldText:'',
                fieldData:[],
                iconStyle:''
            };
        },
        created () {
            this.init();
        },
        mounted () {  
          
        },
        props:{
            config: {
                type: Object,
                default () {
                    return {};
                }
            },
            valueData: {
                type: Object,
                default () {
                    return {};
                }
            },
            curIndex:{
                type:String,
                default:null
            }
        } ,
        methods:{
            input(obj) {
                let temp = {};
                if (obj.name) {
                    temp[obj.name] = obj.value;
                }

                if (obj.textName) {
                    temp[obj.textName] = obj.text;
                }
                if (obj.sname) {
                    temp[obj.sname] = obj.svalue;
                } 
                if (obj.ename) {
                    temp[obj.ename] = obj.evalue;
                }  
                this.data = Object.assign({}, this.data, temp);
                let result = {};
                result.index = this.curIndex;
                result.form  =Object.assign({}, this.data);
                this.$emit('input', result);   
            },

            formChanged(){
                let obj = {};
                obj.index = this.curIndex;
                obj.form  = this.$refs.form.getData();
                this.$emit('input', obj);   
            },
            init() {
                if (this.operflag) {
                    this.formSpan = 22;
                    this.btnSpan = 2;
                } else {
                    this.formSpan = 24;
                    this.btnSpan = 0;
                }
                this.initField();
            },
            initField () {
                Object.assign(this.data,this.valueData);
                let fieldData = [];
                if (this.config.items && this.config.items.length > 0) {
                    this.config.items.forEach(el => {
                        if (el.name && el.label) {
                            fieldData.push({code:el.name,name:el.label});
                            this.dataType[el.name] = Object.assign({},el, {name:'value'});
                            this.dataType[el.name].operData = this.getOperData(el);
                        }
                    });
                }
                this.fieldData = fieldData;
                if (this.valueData.field){
                    let temp = fieldData.find(el => el.code === this.valueData.field);
                    if (temp) {
                        this.fieldText = temp.name;
                        this.fieldChanged(this.valueData.field);
                    }
                } 
            },
            getOperData(el) {
                let tempData = [];
                tempData.push({
                    name: '等于',
                    code: '=='
                });
                if (el.type === 'DateBox' || el.type === 'NumberBox') {
                    tempData.push({
                        name: '不小于',
                        code: '>='
                    });
                    tempData.push({
                        name: '不大于',
                        code: '<='
                    });
                    tempData.push({
                        name: '不等于',
                        code: '<>'
                    });
                } 
                if (el.type === 'TextBox') {
                    tempData.push({
                        name: '不等于',
                        code: '<>'
                    });
                    tempData.push({
                        name: '包含',
                        code: 'LIKE'
                    });
                } 
                if (el.setOperData) {
                    tempData =  el.setOperData(el,tempData);
                }
                return tempData; 
            },
            fieldChanged(value) {
                let self = this;
                let operValue = '==';
                let oper = {};
                if (value) {
                    let config = Object.assign({},this.dataType[value]);
                    oper.data = this.$Method.copy(config.operData);
                    if (config.operDefaultValue) {
                        operValue = config.operDefaultValue;
                    }
                    Object.assign(this.operConfig, {data:oper.data});
                    config.name ='value'; 
                    config.label = '';
                    config.readOnly = false;
                    config.visible = true;
                    config.valueChanged = '';
                    Object.assign(this.valueConfig, config);
                }
                let obj ={};
                obj.oper = operValue;
                obj.value = '';
                Object.assign(self.data, obj);
            },
        
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/layouttemplate/billconditiontwobox.vue